
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component({
  name: "SpeakerCard",
})
export default class SpeakerCard extends Vue {
  @Prop() speaker!: Speaker;

  @Prop({ default: false }) moderator!: boolean;
}
